<template>
  <v-btn
    v-show="showButton"
    v-scroll="onScroll"
    class="ScrollUpButton"
    fixed
    @click="toTop"
  >
    <v-icon>keyboard_arrow_up</v-icon>
  </v-btn>
</template>

<script type="text/javascript">
  const SHOW_BUTTON_OFFSET = 20
  export default {
    props: {
      showButtonOffset: {
        type: Number,
        default: SHOW_BUTTON_OFFSET,
      },
    },
    data() {
      return {
        showButton: false,
      }
    },
    methods: {
      onScroll(e) {
        if (typeof window === 'undefined') {
          return
        }
        const top = window.pageYOffset || e.target.scrollTop || 0
        this.showButton = top > this.showButtonOffset
      },
      toTop() {
        this.$vuetify.goTo(0, { container: document.documentElement, })
      },
    },
  }
</script>

<style scoped lang="scss">
.ScrollUpButton {
  height: 64px !important;
  width: 64px;
  border-radius: 10.24px;
  background-color: $color-102d69 !important;
  box-shadow: 0 8px 16px 0 $color-31_54_139_12;
  bottom: 40px;
  right: 40px;
  z-index: $zIndexScrollUp;
  min-width: inherit !important;
  padding: 0 !important;

  .v-icon {
    font-size: 45px;
    color: $color-ffffff;
  }
}
</style>
